import { render, staticRenderFns } from "./sign-card.vue?vue&type=template&id=40aeefc5&scoped=true"
import script from "./sign-card.vue?vue&type=script&lang=js"
export * from "./sign-card.vue?vue&type=script&lang=js"
import style0 from "./sign-card.vue?vue&type=style&index=0&id=40aeefc5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40aeefc5",
  null
  
)

export default component.exports